// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ImagensServicos_UploadFotoAjaxResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/imagens_servicos/upload_foto_ajax/{id}/{antes_depois}
 *
 * Returns metadata about the just-uploaded photo: the new DB id, the
 * server-generated safe filename, and Azure Blob URLs (with SAS tokens
 * for the private container) for both the original and the thumbnail.
 *
 * Legacy shape exposed these as top-level keys on the AjaxResponse —
 * preserved here under `dados`.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ImagensServicos_UploadFotoAjaxResponseDados {
imagem_id: number
imagem_nome: string
imagem_url: string
imagem_thumbnail_url: string
message: string
}

export type ImagensServicos_UploadFotoAjaxResponse = ApiResponse<ImagensServicos_UploadFotoAjaxResponseDados>;

registerResponseContract('ImagensServicos_UploadFotoAjaxResponse', {
  imagem_id:            { type: 'number',  required: true },
  imagem_nome:          { type: 'string',  required: true },
  imagem_url:           { type: 'string',  required: true },
  imagem_thumbnail_url: { type: 'string',  required: true },
  message:              { type: 'string',  required: true },
})
